import React, { Component, Fragment } from 'react'
import { Link } from 'react-router-dom'
import { NavHashLink } from 'react-router-hash-link'
import Button from '../ui/Button'
import logoColor from '@assets/icons/logo_color.svg'
import logo from '@assets/icons/logo.svg'

import './mainNav.sass'

class MainNav extends Component {
  constructor(props) {
    super(props)

    this.state = {
      opened: false,
    }
  }

  toggleMenu() {
    this.setState({ opened: !this.state.opened })
  }

  analytics(act, lab) {
    const labObject = lab ? { eventLab: lab } : {}

    window.dataLayer?.push({
      event: lab ? 'domEventLab' : 'domEvent',
      eventCat: 'Header',
      eventAct: act,
      ...labObject,
    })
  }

  renderLogo() {
    return (
      <Link to="/" className="logo-link" onClick={() => this.analytics('Logo')}>
        <img src={logoColor} alt="logo" />
      </Link>
    )
  }

  renderLinks() {
    return (
      <Fragment>
        <NavHashLink
          to="/#addresses-section"
          onClick={() => this.analytics('Interactions', 'Nos adresses')}
        >
          <span className="middle-button">Nos adresses</span>
        </NavHashLink>
        <Link to={'/contact'} onClick={() => this.analytics('Interactions', 'Besoin d’aide')}>
          <span className="middle-button">Besoin d’aide ?</span>
        </Link>
      </Fragment>
    )
  }

  renderDesktopLinks() {
    if (this.props.lightVersion) return null

    return <div className="desktop ml-6">{this.renderLinks()}</div>
  }

  getSubscriptionLink() {
    const { ctaLink } = this.props
    if (ctaLink) return ctaLink

    return '/inscription/email'
  }

  renderRightLinks() {
    if (this.props.lightVersion) return null

    return (
      <div className="MainNav-links">
        <Link
          to={this.getSubscriptionLink()}
          onClick={() => this.analytics('Obtenir mon prix', 'MainNav')}
        >
          <Button secondaryClass="primary small-height sm-font" label="Obtenir mon prix" />
        </Link>
        <Link to="/login" onClick={() => this.analytics('Login')}>
          <Button secondaryClass="btn-nav sm-font border-b" label="SE CONNECTER" />
        </Link>
      </div>
    )
  }

  renderPhone() {
    return (
      <div className="phone">
        <div className="phone-icon" />
        <div>
          <a href="tel:0175850653">
            <p className="number">01 75 85 06 53</p>
          </a>
          <p className="number-info">Appel Gratuit</p>
        </div>
      </div>
    )
  }

  renderMenuMobile() {
    return (
      <div id="menu-mobile" className={this.state.opened ? '' : 'hidden'}>
        <div className="container-logo-close">
          <Link to={`/`} onClick={() => this.analytics('Logo')}>
            <img src={logo} alt="logo" />
          </Link>
          <div className="close-menu" onClick={() => this.toggleMenu()} />
        </div>
        <div className="menu-link">{this.renderLinks()}</div>
        <div className="action-nav-mobile">
          {this.renderPhone()}
          <Link
            className="btn btn-nav orange"
            to={this.getSubscriptionLink()}
            onClick={() => this.analytics('Obtenir mon prix')}
          >
            Obtenir mon prix
          </Link>
          <Link className="btn btn-nav" to="/login" onClick={() => this.analytics('Se domicilier')}>
            Se connecter
          </Link>
        </div>
      </div>
    )
  }

  render() {
    return (
      <div className={`main-nav ${this.props.secondaryClass || ''}`}>
        <div className="nav-logo">
          <div className="drop-button" onClick={() => this.toggleMenu()} />
          {this.renderLogo()}
          {this.renderDesktopLinks()}
        </div>
        <div className="action-nav">
          {this.renderPhone()}
          {this.renderRightLinks()}
        </div>
        {this.renderMenuMobile()}
      </div>
    )
  }
}

export default MainNav
